/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Return_HomeInputs */

const en_agent_authorization_return_home = /** @type {(inputs: Agent_Authorization_Return_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Return to Seek AI`)
};

const zh_agent_authorization_return_home = /** @type {(inputs: Agent_Authorization_Return_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回 Seek AI`)
};

/**
* | output |
* | --- |
* | "Return to Seek AI" |
*
* @param {Agent_Authorization_Return_HomeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_return_home = /** @type {((inputs?: Agent_Authorization_Return_HomeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Return_HomeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_return_home(inputs)
	return zh_agent_authorization_return_home(inputs)
});
export { agent_authorization_return_home as "agent.authorization.return_home" }